var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',{staticClass:"footer"},[_vm._v("© 上海法法信息技术有限公司")])
}
var staticRenderFns = []

export { render, staticRenderFns }